export default __webpack_public_path__ + "static/media/36.f44f1e8f.mp3";